export function recordProductSearchConversion(query, productId) {
  if (!query || query.length < 3 || !productId) return

  navigator.sendBeacon('/search_conversions', new URLSearchParams({
    'search_conversion[query]': query,
    'search_conversion[product_id]': productId
  }))
}
